import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import type { SortDirection } from '../../hooks/useSortableData';

interface SortableTableHeaderProps {
  label: string;
  field: string;
  sortField: string | null;
  sortDirection: SortDirection;
  onSort: (field: string) => void;
  className?: string;
}

export function SortableTableHeader({
  label,
  field,
  sortField,
  sortDirection,
  onSort,
  className = '',
}: SortableTableHeaderProps) {
  return (
    <th
      className={`px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 ${className}`}
      onClick={() => onSort(field)}
    >
      <div className="flex items-center space-x-1">
        <span>{label}</span>
        {sortField === field && (
          sortDirection === 'asc' ? (
            <ChevronUpIcon className="h-4 w-4" />
          ) : (
            <ChevronDownIcon className="h-4 w-4" />
          )
        )}
      </div>
    </th>
  );
}
